export const LGBTQ_TAG_VALUE = 'lgbtq+ community experience'

export const tagImages = {
  [LGBTQ_TAG_VALUE]: '/icons/lgbtq-tag.svg',
  'top-rated counselor': '/icons/top-rated-tag.svg',
}

// Testimonials — shared across TestimonialsSection and FeaturedTestimonial (sticky header)
export const TESTIMONIAL_TRUNCATE_SUFFIX = '....'

export const TESTIMONIAL_LIST_TRUNCATE_LENGTH = 180
export const TESTIMONIALS_INITIAL_COUNT_MOBILE = 3
export const TESTIMONIALS_INITIAL_COUNT_DESKTOP = 4
export const TESTIMONIAL_SCROLL_RETRY_INTERVAL_MS = 50
export const TESTIMONIAL_SCROLL_RETRY_MAX_ATTEMPTS = 40

export const TESTIMONIALS_DISCLAIMER_TEXT =
  'Testimonials are from real patients who completed a post-session satisfaction survey and agreed to share their feedback. Results may vary.'

export enum SessionOfferingType {
  ONLINE_ONLY = 'online_only',
  IN_PERSON_ONLY = 'in_person_only',
  BOTH = 'both',
  NO_SCHEDULE = 'no_schedule',
}

export enum ProviderServiceType {
  PSYCHIATRY = 'psychiatry',
  THERAPY = 'therapy',
}

// Intro video tracking — sent with the Video Started / Video Played events.
export const VIDEO_ENTRY_POINT = {
  HEADER: 'header',
  ABOUT: 'about',
} as const

export type VideoEntryPoint = typeof VIDEO_ENTRY_POINT[keyof typeof VIDEO_ENTRY_POINT]

// Follows the player the user gets: native fullscreen (mobile) vs inline (desktop).
export const VIDEO_DEVICE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
} as const

export type VideoDevice = typeof VIDEO_DEVICE[keyof typeof VIDEO_DEVICE]
